var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "apply_kid_dialog",
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.isAddStudentUpdateAlbumDialog,
            "show-close": true,
            "close-on-click-modal": false,
            width: "70%",
            top: "100px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isAddStudentUpdateAlbumDialog = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticClass: "title_dialog" }, [
                    _c("span", [_vm._v("Danh sách học sinh")]),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "dialog-footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.handleClose },
                        },
                        [
                          _c("i", { staticClass: "el-icon-circle-close" }),
                          _vm._v("\n          Hủy bỏ\n        "),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.handleSaveForm()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-circle-check" }),
                          _vm._v("\n          Xác nhận\n        "),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "body_dialog" }, [
            _c(
              "div",
              { staticClass: "section_filter" },
              [
                _c(
                  "el-row",
                  { attrs: { type: "flex", gutter: 6 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "90%" },
                            attrs: {
                              multiple: "",
                              filterable: "",
                              "allow-create": "",
                              "default-first-option": "",
                              limit: 1,
                              placeholder: "Chọn lớp",
                            },
                            on: { change: _vm.handleChangeFilter },
                            model: {
                              value: _vm.classesApply,
                              callback: function ($$v) {
                                _vm.classesApply = $$v
                              },
                              expression: "classesApply",
                            },
                          },
                          _vm._l(_vm.listClass, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.className, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.classesApply.length > 0
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "90%" },
                              attrs: {
                                clearable: true,
                                placeholder: "Nhập tên học sinh",
                              },
                              on: {
                                change: _vm.handleChangeFilter,
                                clear: _vm.handleChangeFilter,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "append",
                                    fn: function () {
                                      return [
                                        _c("el-button", {
                                          attrs: { icon: "el-icon-search" },
                                          on: { click: _vm.handleChangeFilter },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                1853576214
                              ),
                              model: {
                                value: _vm.nameKids,
                                callback: function ($$v) {
                                  _vm.nameKids = $$v
                                },
                                expression: "nameKids",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                class:
                  _vm.kidsDataFilter.length === 0
                    ? "wrap_data no_data"
                    : "wrap_data",
              },
              [
                _vm.kidsDataFilter.length > 0
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-bottom": "10px",
                            "margin-bottom": "10px",
                            "border-bottom": "1px solid #ccc",
                          },
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { indeterminate: _vm.isIndeterminate },
                              on: { change: _vm.handleCheckAllChange },
                              model: {
                                value: _vm.checkAll,
                                callback: function ($$v) {
                                  _vm.checkAll = $$v
                                },
                                expression: "checkAll",
                              },
                            },
                            [_vm._v("\n              Tất cả\n            ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { height: "400px", overflow: "auto" } },
                        _vm._l(_vm.kidsDataFilter, function (item) {
                          return _c(
                            "div",
                            { key: item.idClass },
                            [
                              _c(
                                "el-divider",
                                { attrs: { "content-position": "left" } },
                                [
                                  _c("div", [
                                    _c("i", { staticClass: "el-icon-star-on" }),
                                    _c("span", { staticClass: "title_group" }, [
                                      _vm._v(_vm._s(item.className)),
                                    ]),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.idKidApply,
                                    callback: function ($$v) {
                                      _vm.idKidApply = $$v
                                    },
                                    expression: "idKidApply",
                                  },
                                },
                                _vm._l(item.students, function (kid) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: kid.idKid,
                                      staticStyle: {
                                        width: "33.333333%",
                                        "margin-right": "0",
                                      },
                                      attrs: { label: kid.idKid },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(kid.kidsName) +
                                          " - " +
                                          _vm._s(
                                            _vm.parseKidStatusVietnamese(
                                              kid.statusKids
                                            )
                                          ) +
                                          " (" +
                                          _vm._s(kid.className) +
                                          ")\n                "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ])
                  : _c("div", { staticStyle: { color: "#78a5e7" } }, [
                      _c("i", { staticClass: "el-icon-warning" }),
                      _vm._v("\n          Không có dữ liệu\n        "),
                    ]),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }